const STORAGE_KEY = 'openJobsAppliedJobIds';

function readAppliedJobIds() {
	try {
		const parsed = JSON.parse(window.localStorage.getItem(STORAGE_KEY));
		if (!Array.isArray(parsed)) {
			return [];
		}
		return parsed.map(Number).filter(id => Number.isInteger(id) && id > 0);
	} catch {
		return [];
	}
}

export function hasAppliedToJob(jobId) {
	const id = Number(jobId);
	if (!id) {
		return false;
	}
	return readAppliedJobIds().includes(id);
}

export function markJobAsApplied(jobId) {
	const id = Number(jobId);
	if (!id) {
		return;
	}

	const ids = readAppliedJobIds();
	if (ids.includes(id)) {
		return;
	}

	try {
		window.localStorage.setItem(STORAGE_KEY, JSON.stringify([...ids, id]));
	} catch {
		// Ignore quota / private-mode failures; the Applied state still
		// updates in memory for the current visit.
	}
}
